module.exports = __webpack_public_path__ + "static/media/vis.d9dd4c37.jpg";